export const POLICY_ROUTER_ECO_SERVICES = {
  POLICY_ROUTER: "PolicyRouterAPI",
  WRAPPER: "PolicyWrapperAPI",
  POLICY_LOOKUP: "PolicyLookupAPI",
};
